import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/merchants/inbounds/inventory_batches'

const MerchantInventoryBatchesApiV2 = {

  /**
   * Create inventory batch ednpoint.
   * Invoke `POST api/v2/admins/merchants/inbounds/inventory_batches`
   * @param {string} photo_studio_location location of the batch in the studio
   * @param {array} skus list of sku of merchant_inbound_item that will be put in one batch
   * @param {inbound_id} Merchant::Inbound ID
   */
  create: ({
    photo_studio_location,
    skus,
    inbound_id
  }) => {
    const path     = API_PATH
    const body     = {
      inventory_batch: {
        photo_studio_location : photo_studio_location,
        skus                  : skus,
        inbound_id            : inbound_id
      }
    }
    const response = axios.post(path, body)
    return response
  },
  /**
   * Get list of Merchant Inventory Batch
   * Invoke `GET api/v2/admins/merchants/inbounds/inventory_batches
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Show Merchant Inventory Item by specific id
   * Inovke `GET api/v2/admins//merchant/inbounds/inventory_batches/:id`
   * @param {number} id Merchant Inventory Item Id's ID
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  /**
   * Show Merchant Inventory Items by specific inventory_id
   * Inovke `GET api/v2/admins//merchant/inbounds/inventory_batches/:id/items`
   * @param {number} id Merchant Inventory Id's ID
   */
  getItems: async ({ tableState, additionalFilters, inventory_batch_id }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/${inventory_batch_id}/items`

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Show Rejected Items by specific inventory_id
   * Inovke `GET api/v2/admins/merchants/inbounds/inventory_batches/:id/rejected_items`
   * @param {number} id Merchant Inventory Id's ID
   */
  getRejectedItems: async ({ tableState, additionalFilters, inventory_batch_id }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/${inventory_batch_id}/rejected_items`

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Change Merchant::Inbound::InventoryBatch::Item.photo_received_status to 'completed'
   * Inovke `PATCH api/v2/admins/merchant/inbounds/inventory_batches/items/photo_studio_received`
   * @param {string} sku - Merchant Inventory Batch Item sku
   * @param {number} inventory_batch_id - Merchant Inventory Batch Id
   */
  receiveItem: async ({ sku, inventory_batch_id }) => {
    const endpoint = `${API_PATH}/items/photo_studio_received`
    const payload  = {
      sku                : sku,
      inventory_batch_id : inventory_batch_id
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  /**
   * Change Merchant Inventory Batch Warehouse Status to 'received' by specific inventory_id
   * Inovke `GET api/v2/admins//merchant/inbounds/inventory_batches/:id/warehouse_received`
   * @param {number} id Merchant Inventory Id's ID
   */
  warehouseReceived: async ({ inventory_batch_id }) => {
    const path     = `${API_PATH}/${inventory_batch_id}/warehouse_received`
    const response = axios.patch(path)
    return response
  },

  /**
   * Change Merchant Inventory Batch Photo process status to 'photography_completed' by specific inventory_id
   * Inovke `PATCH api/v2/admins//merchant/inbounds/inventory_batches/:id/photography_completed`
   * @param {number} id Merchant Inventory Id's ID
   */
  photographyCompleted: async ({ id }) => {
    const path     = `${API_PATH}/${id}/photography_completed`
    const response = axios.patch(path)
    return response
  },

  /**
   * Change Merchant Inventory Batch Photo Studio Status to 'received' by specific inventory_id
   * Inovke `GET api/v2/admins//merchant/inbounds/inventory_batches/:id/photo_studio_received`
   * @param {number} id Merchant Inventory Id's ID
   */
  PhotoStudioReceived: async ({ id }) => {
    const path     = `${API_PATH}/${id}/photo_studio_received`
    const response = axios.patch(path)
    return response
  },

  /**
   * Change Merchant Inventory Batch Put Away Status to 'completed' by specific inventory_id
   * Inovke `GET api/v2/admins//merchant/inbounds/inventory_batches/:id/put_away_completed`
   * @param {number} id Merchant Inventory Id's ID
   */
  PutAwayCompleted: async ({ id }) => {
    const path     = `${API_PATH}/${id}/put_away_completed`
    const response = axios.patch(path)
    return response
  },

  /**
   * Change Merchant Inventory Batch Photo Process Status to 'photo_edit_completed' by specific inventory_id
   * Inovke `GET api/v2/admins//merchant/inbounds/inventory_batches/:id/photo_edited`
   * @param {number} id Merchant Inventory Id's ID
   */
  PhotoEditCompleted: async ({ id }) => {
    const path     = `${API_PATH}/${id}/photo_edit_completed`
    const response = axios.patch(path)
    return response
  }

}

export default MerchantInventoryBatchesApiV2
